<template>
    <v-flex class="title-block" v-if="device">
        <div class="img-container">
            <div v-html="require(`!html-loader!@/assets/device-icons/${deviceTypes[device.device_type].img}.svg`)" />
        </div>
        <div class="title-block__name">
            {{ device.name }}
        </div>
    </v-flex>
</template>

<script>
import deviceTypes from '@/plugins/deviceTypes.js';

export default {
    name: "DeviceTitle",
    props: {
        device: {
            type: [Array, Object],
            default: null,
        }
    },
    data() {
        return {
            deviceTypes: deviceTypes,
        };
    },
}
</script>